import { css } from '@emotion/react';
import { Z_INDEX } from '../../constants/zIndex';

const supportMenuStyle = {
    buttonLang: css({
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '24px',
        lineHeight: '24px',
        border: 'none',
        textTransform: 'uppercase',
        outline: 'none',
        cursor: 'pointer',
        backgroundColor: 'transparent',
        boxShadow: 'none',
    }),
    buttonLangWhite: css({
        background: '#ffffff',
        color: '#101010',
    }),
    buttonLangBlack: css({
        background: '#101010',
        color: '#ffffff',
    }),
    langList: css({
        textAlign: 'center',
        transition: '0.3s',
        overflow: 'hidden',
        zIndex: Z_INDEX.SUPPORT_MENU_DESKTOP,
        backgroundColor: '#ffffff',
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        width: '100%',
        padding: '20px 16px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
    }),
    langListDesktop: css({
        position: 'absolute',
        top: 13,
        right: 14,
        width: 375,
        boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.1)',
        borderRadius: 8,
    }),
    langListItem: css({
        fontSize: '1.5rem',
        fontWeight: 300,
        color: '#ffffff',
    }),
    langListItemActive: css({
        color: '#FFF300',
        fontWeight: 'bold',
    }),
    container: css({
        position: 'relative',
    }),
    backdrop: css({
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#000000CC',
        zIndex: Z_INDEX.OVERLAY_BACKDROP,
    }),
    innerBox: css({
        width: '100%',
        height: '100%',
        position: 'absolute',
    }),
    radioInput: css({
        color: '#000000',
        fontSize: 15,
        marginBottom: 24,
        display: 'flex',
        alignItems: 'center',

        '@media (min-width: 600px)': {
            marginBottom: 20,

            '&:last-of-type': {
                marginBottom: 0,
            },
        },
    }),
    labelSpan: css({
        marginRight: 12,
        marginLeft: 12,
    }),
    header: css({
        fontSize: 15,
        fontWeight: 600,
        margin: 0,
        textAlign: 'center',
        width: '100%',
    }),
    stationContainer: css({ padding: 0, paddingTop: 20 }),
};

export default supportMenuStyle;
